// NotFound.tsx — the catch-all route.
//
// Without it, a URL matching no route rendered an empty `#root`: no message, no navigation,
// nothing in the console. That is indistinguishable from the app failing to boot, and it cost
// a long debugging detour on 2026-08-07 (a mistyped `/bots` — the bot list lives at `/`) that
// looked exactly like the blank-page incident the inline guard in index.html exists for.
// A wrong address should say so.
import { Link } from 'react-router';
import { Button } from '@repo/ui/components/button';
import { useT } from '../locales/context';

export function NotFound() {
  const t = useT();
  return (
    <div className="grid min-h-screen place-items-center px-6">
      <div className="flex max-w-md flex-col items-center gap-3 text-center">
        <p className="text-sm font-medium text-muted-foreground">{t.auth.notFoundEyebrow}</p>
        <h1 className="text-xl font-semibold">{t.auth.notFoundTitle}</h1>
        <p className="text-sm text-muted-foreground">{t.auth.notFoundBody}</p>
        <Button asChild className="mt-2">
          <Link to="/">{t.auth.notFoundCta}</Link>
        </Button>
      </div>
    </div>
  );
}
